var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pet-container"}},_vm._l((_vm.filterPets),function(pet){return _c('pet-card',{key:pet.name,staticClass:"flip-card",attrs:{"id":"myCard","pet":pet}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }